/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Linkable } from '@/components/blocks/Linkable';
import { error404ContainerSX } from '@/components/content/Error404/styles/container';
import { error404LinkSX, error404TypographySX } from '@/components/content/Error404/styles/typography';
import { useLocalization } from '@/data/Localization';
import { useSettings } from '@/data/Settings';
import { ID } from '@/data/types/Basic';
import { CardMedia, Paper, Typography } from '@mui/material';
import { FC } from 'react';

export const Error404: FC<{ id: ID }> = () => {
	const CommonLabels = useLocalization('Common');
	const RouteLocal = useLocalization('Routes');
	const {settings} = useSettings();
	return (
		<Paper sx={error404ContainerSX}>
			<Typography component="div" variant="subtitle2" sx={error404TypographySX}>
				<CardMedia
					src={`${settings.userData.StaticHostSecure}/wcsstore/IntertoysSAS/images/colors/color1/page-not-found-error-image-404.png`} 
					component='img'
				/>
				<Linkable
					type="button"
					href={`/${RouteLocal.HomePage.route.t()}`}
					variant="contained"
					sx={error404LinkSX}
				>
						{CommonLabels.Actions.ContinueShopping.t()}
				</Linkable>
			</Typography>
		</Paper>
	);
};
